// 📁 src/utils/dateUtils.js
import dayjs from "dayjs";

export function formatDOB(date) {
  const parsed = dayjs(date, ["D.M.YYYY", "DD.MM.YYYY", "YYYY-MM-DD"], true);
  return parsed.isValid() ? parsed.format("DD.MM.YYYY") : "—";
}
